/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-08-30 11:06:48
 * @FilePath: \monitor\src\main.js
 * @Description:
 */
import Vue from "vue";
import App from "./App";
import store from "./store";
import VueRouter from "vue-router";
import { router } from "./router/index";
import "./styles/common.less";
import jquery from "jquery";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import EN from "view-design/dist/locale/en-US";
import CN from "view-design/dist/locale/zh-CN";
import jtSpin from "./components/jt-spin/index.vue";
import Meta from "vue-meta";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(Meta);
Vue.use(VueRouter);
Vue.component("jtSpin", jtSpin);
Vue.prototype.$ = jquery;
Vue.config.productionTip = false;
//中英文切换
import LanguageData from "./language/index"; //中文最终汇总暴露的信息
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
Vue.locale = () => {};
const messages = {
  EN: Object.assign(LanguageData.EN, EN),
  CN: Object.assign(LanguageData.CN, CN)
};
const i18n = new VueI18n({
  locale: sessionStorage.getItem("languageSet") || serverConfig.language, // set locale
  messages // set locale messages
});
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
});

new Vue({
  el: "#app",
  router: router,
  store: store,
  i18n, //把 i18n 挂载到 vue 根实例上
  components: { App },
  template: "<App/>"
});
// 把i18n导出给单独的js文件来引用
export default i18n;
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

Array.prototype.inArray = function(e) {
  var r = new RegExp("," + e + ",");
  return r.test("," + this.join(this.S) + ",");
};



// WEBPACK FOOTER //
// ./src/main.js